// import OReport from "@heytap/oreport
const OReport = (window as any).oReport
let oreport: any = undefined
if (OReport && location.hostname === "file-system.ait.oppoer.me") {
    oreport = new OReport({
        id: 102,
        appKey: "6780182a81a002e31a1bde0b39b04dd2",
        console: true,
        delay: 3 * 1000,
        random: 1,
        ignore: [/ResizeObserver/, /NavigationDuplicated/],
        onReport: (id, log) => {
            console.log(`onReport id: ${id}, log: ${JSON.stringify(log)}`)
        },
        beforeReport: params => {
            const msg = params && typeof params.msg === 'string' ? params.msg : ''
            const id = (window as any).userId
            params.msg = id + " " + msg
            const nd = 'NavigationDuplicated',
                ro = 'ResizeObserver'
            return !(msg.includes(nd) || msg.includes(ro))
        }
    })
}
export default oreport
